import { defineComponent as _defineComponent } from 'vue'
import { StudioEvent } from '@/modules/Studios/types'
import { computed, ref } from 'vue'
import { useImage } from '@/shared/composables/image'
import { getDateFormatted } from '@/services/date'
import { mdiChevronDown, mdiChevronUp } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioEventChip',
  props: {
    event: null,
    isExpandable: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { event: StudioEvent, isExpandable: boolean };



const { getEventImg } = useImage()

const isExpanded = ref(!props.isExpandable)
const eventDate = computed(() => getDateFormatted(new Date(props.event.dateStart)))

const getRankText = (rank: number): string => {
  if (rank === 1) return '1st'
  if (rank === 2) return '2nd'
  if (rank === 3) return '3rd'
  if (rank === 4) return 'Top 4'
  if (rank === 5) return 'Top 5'
  return ''
}

const getRankIconClass = (rank: number): string => {
  if (rank === 1) return 'rank-icon icon-gold'
  if (rank === 2) return 'rank-icon icon-silver'
  if (rank === 3) return 'rank-icon icon-bronze'
  return 'rank-icon icon-compete'
}

return { __sfc: true,props, getEventImg, isExpanded, eventDate, getRankText, getRankIconClass, mdiChevronDown, mdiChevronUp }
}

})